import * as React from 'react';
import { useIntl } from 'react-intl';
import usePageWithForm from '../../hooks/usePageWithForm';
import WizardNew from '../Wizard';
import useDocumentTitle from '../../hooks/useDocumentTitle';

export default function ImportRefuelingsWizardNew(): JSX.Element {
  usePageWithForm();
  const { formatMessage: f } = useIntl();
  const documentTitle = `${f({ id: 'table.addBtn' })} - ${f({
    id: 'tab.expense/import/record',
  })} - ${f({
    id: 'menu.expenseImports',
  })} `;
  useDocumentTitle(documentTitle);
  return (
    <div className="system-settings col-12">
      <form className="col-6">
        <WizardNew for="expense" />
      </form>
    </div>
  );
}
